"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    ITEM_LINK_CLASS_NAME: 'navigation-menu-item',
    SUB_ITEM_LINK_CLASS_NAME: 'navigation-menu-sub-item',
    ACTIVE_ITEM_CLASS_NAME: 'active',
    BASE_ZINDEX: 50,
    NAVIGATION_SHRUNK_MATCHES_COOKIE_KEY: 'navigation-shrunk-matches',
};
